// extracted by mini-css-extract-plugin
export default {"container":"SimpleAuth_container__NkFJX","button":"SimpleAuth_button__ZAGNc"};